<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadSummary="loadSummary"
      @loadTable="loadTable"
      @loadUser="loadUser"
    ></results-bar>
    <results-summary
      v-if="mode === 'summary'"
      :key="mode"
      :id="doc.id"
    ></results-summary>
    <results-user
      v-if="mode === 'user'"
      :key="mode"
      :uid="currentUser"
    ></results-user>
    <results-table
      v-if="mode === 'table'"
      :key="mode"
      :id="doc.id"
      :doc="doc"
    ></results-table>
    <!-- <results-debug
      v-if="mode === 'debug'"
      :key="mode"
      :id="doc.id"
      :doc="doc"
    ></results-debug> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { store } from "@/store.js";
import {
  ResultsSummary,
  ResultsUser,
  ResultsBar,
  ResultsTable,
} from "@/components/results/tov";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ResultFunctionality",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
      mode: "table",
    };
  },
  components: {
    ResultsSummary,
    ResultsUser,
    ResultsBar,
    ResultsTable,
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState(["exTov"]),
  },
  methods: {
    loadSummary() {
      this.currentUser = null;
      this.mode = "summary";
    },
    loadTable() {
      this.currentUser = null;
      this.mode = "table";
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.mode = "user";
    },
    getExercise() {
      let ref = fb.tovExCollection.where("pid", "==", this.doc.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          let users = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
            items.push(post);
          });
          if (items) {
            store.commit("setExTov", items);
          }
          if (users) {
            this.userList = users;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
